class PostModel{
  constructor(id,image,title,type,userid,tages,description,date,thumbnail,views,vcomments,vlikes,vdislikes,userImg,email,link,followers){
    this.id =id;
   this.image = image;
   this.title = title;
   this.type = type;
   this.userid = userid;
   this.tages = tages;
   this.description = description;
    this.thumbnail = thumbnail;
    this.date = date;
    this.views = views;
    this.vcomments = vcomments;
    this.vlikes = vlikes;
    this.vdislikes = vdislikes;
    this.userImg = userImg;
    this.email = email;
    this.link = link;
    this.followers = Number(followers) || 0;
  }
}
export default PostModel;
